<!-- InfoRow.vue -->
<template>
  <b-row class="mb-2 pl-3 pr-3">
    <b-col sm="6">
      <div class="d-flex">
        <div class="flex-grow-1 text-capitalize">{{ label }}</div>
        <span>:</span>
      </div>
    </b-col>
    <b-col sm="6" :class="customClass" v-if="['Anamnesa', 'Keluhan'].includes(label)"><div v-html="value || '-'"></div></b-col>
    <b-col sm="6" :class="customClass" v-else>{{ formattedValue || "-" }}</b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    label: String,
    value: [String, Number],
    customClass: String
  },
  computed: {
    formattedValue() {
      switch (this.label.toLowerCase()) {
        case "tinggi badan":
          return this.value ? `${this.value} cm` : "-";
        case "berat badan":
          return this.value ? `${this.value} kg` : "-";
        case "tensi sistole":
        case "tensi diastole":
          return this.value ? `${this.value} mmHg` : "-";
        case "suhu":
          return this.value ? `${this.value} °C` : "-";
        case "nadi":
        case "respirasi":
          return this.value ? `${this.value} /menit` : "-";
        case "lingkar perut":
          return this.value ? `${this.value} cm` : "-";
        case "imt":
          return this.value ? `${this.value} kg/m²` : "-";
        case "saturasi oksigen":
          return this.value ? `${this.value} %` : "-";
        default:
          return this.value;
      }
    }
  }
};
</script>

<style scoped></style>
